<template>
    <div class="text_modal_wrapper" :class="{ small }">
        <div class="modal_bg"></div>
        <div class="text_modal">
            <svg class="close_img" @click="closeModal" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z" fill="white"/>
            </svg>
            <slot name="body">
              <div style="clear:both"></div>
              <div v-if="title" class="text_modal__title">{{ title }}</div>
              <div class="text" v-html="text"></div>
            </slot>
        </div>
    </div>
</template>

<script>
import ConfirmationInput from './ConfirmationInput.vue'

export default {
    name: "TextModal",
    props: {
      title: {
        type: String,
      },
      text: {
        type: String,
      },
      small: {
        type: Boolean,
      },
    },
    components: {
      ConfirmationInput
    },
    methods: {
        closeModal() {
          this.$emit('closeModal')
        }
    }
}
</script>

<style lang="scss">
  .text_modal_wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    z-index: 12;

    .modal_bg {
      position: absolute;
      background: rgba(38, 35, 41, 0.5);
      backdrop-filter: blur(2.5px);
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }

    .text_modal {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      min-width: 320px;
      max-width: 455px;
      height: fit-content;

      border-radius: 16px;
      background: var(--layout-bg);
      border: 1px solid var(--border-color);
      padding: 24px 24px;

      .close_img {
        float: right;
        cursor: pointer;
      }

      .modal_icon {
        text-align: center;
        padding: 10px;
        margin-bottom: 30px;

        svg {
          width: 106px;
          height: 106px;
        }
      }

      .text_modal__title {
        display: flex;
        justify-content: center;
        font-size: 18px;
        padding-bottom: 20px;
        margin-bottom: 20px;
        border-bottom: 1px solid var(--layout-bg-lighter);
      }

      .load_icon svg {
        animation: loaderAnimation 1.5s linear infinite;
      }

      ::-webkit-scrollbar {
        width: 8px;
      }

      ::-webkit-scrollbar-track {
        background: #403a45;
        border-radius: 5px;
      }

      ::-webkit-scrollbar-thumb {
        transition: background-color 0.5s ease;
        background-color: grey;
        border-radius: 5px;
      }

      ::-webkit-scrollbar-thumb:hover {
        cursor: pointer;
        background-color: lightgray;
      }
    }

    .text {
      overflow-y: auto;
      max-height: 440px;
      color: var(--text-color-secondary);
      margin-top: 15px;

      p {
        margin: revert;
        padding: revert;
      }
      h2 {
        font-size: 16px;
        font-weight: 400;
        color: var(--text-color-primary);
      }
      h4 {
        color: #FFF;
        text-align: center;
        font-family: "Rubik", sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 135%;
        margin-top: 24px;
        text-align: left;
      }

      ul {
        margin: revert;
        padding: revert;

        li {
          list-style: square;
          margin: revert;
          padding: revert;
        }
      }
    }

    @keyframes loaderAnimation {
      0% {
        transform: rotateZ(0deg);
      }
      100% {
        transform: rotateZ(360deg);
      }
    }

    @media (max-width: 920px) {
      .text_modal {
        max-height: 562px;
        top: 100%;
        transform: translateY(-100%);
      }
    }
  }
</style>